import { ReactNode, useEffect } from 'react';

import { useAuthContext } from 'src/auth/hooks';
import { useConfigStore } from 'src/stores/config';
import { getCalendarConfig, getSystemSettingConfig } from 'src/services/config';

interface ConfigProviderProps {
  children: ReactNode;
}

export function ConfigProvider({ children }: ConfigProviderProps) {
  const { setCalendarConfig, setSystemSettingConfig } = useConfigStore();
  const { user } = useAuthContext();

  useEffect(() => {
    // 仅在用户已登录时获取配置
    if (user) {
      const loadConfigs = async () => {
        try {
          const [calendarConfig, systemSettingConfig] = await Promise.all([
            getCalendarConfig(),
            getSystemSettingConfig(),
          ]);
          setCalendarConfig(calendarConfig);
          setSystemSettingConfig(systemSettingConfig);
        } catch (error) {
          // 错误处理
        }
      };

      loadConfigs();
    }
  }, [setCalendarConfig, setSystemSettingConfig, user]);

  return <>{children}</>;
} 